import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useCart } from "@/context/CartContext";
import { CustomerChip } from "@/components/CustomerChip";

export const Header = () => {
  const { count, setSheetOpen } = useCart();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const goSection = (id) => (e) => {
    e.preventDefault();
    if (pathname !== "/") navigate(`/#${id}`);
    else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const openCart = () => {
    if (pathname !== "/") return navigate("/");
    if (window.innerWidth < 1024) setSheetOpen(true);
    else document.getElementById("pesananmu")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const link = "text-[15px] text-ink/80 hover:text-forest transition-colors";
  return (
    <header className="sticky top-0 z-40 bg-cream/85 backdrop-blur-md border-b border-sage-200/70">
      <div className="wrap flex items-center justify-between h-[72px] sm:h-20">
        <Link to="/" aria-label="Beranda"><Logo /></Link>
        <nav className="flex items-center gap-3 sm:gap-8">
          <a href="/#menu" onClick={goSection("menu")} className={`${link} hidden md:inline`} data-testid="nav-menu-link">Menu</a>
          <a href="/#cara-pesan" onClick={goSection("cara-pesan")} className={`${link} hidden md:inline`} data-testid="nav-cara-pesan-link">Cara Pesan</a>
          <a href="/#suasana" onClick={goSection("suasana")} className={`${link} hidden lg:inline`} data-testid="nav-suasana-link">Suasana</a>
          <a href="/#lokasi" onClick={goSection("lokasi")} className={`${link} hidden lg:inline`} data-testid="nav-lokasi-link">Lokasi</a>
          <Link to="/pesanan" className={`${link} hidden sm:inline`} data-testid="nav-pesanan-saya-link">Pesanan Saya</Link>
          <CustomerChip />
          <button onClick={openCart} className="relative p-2 -mr-2 hover:scale-105 transition-transform" data-testid="nav-cart-button" aria-label="Keranjang">
            <ShoppingBag className="w-7 h-7 text-ink" strokeWidth={1.6} />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[22px] h-[22px] px-1 rounded-full bg-forest text-paper text-xs font-bold grid place-items-center" data-testid="nav-cart-count">
                {count}
              </span>
            )}
          </button>
        </nav>
      </div>
    </header>
  );
};
